import { useEffect, useState } from "react";
import { FormModal } from "../../../CommonElements";
import FormTambahCuti from "../../Cuti/components/FormTambahCuti";
import { useAbsensi } from "../../../Context/AbsensiContext";

const ModalCuti = ({ isOpen, toggle, data, refreshStaff }) => {
  const absensiAPI = useAbsensi()
  const [tipeAbsensi, setTipeAbsensi] = useState([]);

  useEffect(() => {
    if (isOpen) {
      refreshTipeAbsensi();
    }
  }, [isOpen]);

  const user = [{
    id: data?.id,
    nama: data?.nama
  }]

  const refreshTipeAbsensi = () => {
    absensiAPI.getTipeAbsensi().then((res) => {
      setTipeAbsensi(res.data);
    });
  };

  return (
    <FormModal title={"Ajukan Cuti"} isOpen={isOpen} toggle={toggle}>
      <FormTambahCuti
        resetState={refreshStaff}
        toggle={toggle}
        tipeAbsensi={tipeAbsensi}
        create={true}
        staf={user}
      />
    </FormModal>
  );
};

export default ModalCuti;
